/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Translation } from "react-i18next";
import "../../../css/Delivery.css";
import icInstore from "../../../images/eshop/icon-instore.svg";
import icInternDelivery from "../../../images/eshop/icon-global-delivery.svg";
import icLocalDelivery from "../../../images/eshop/icon-local-delivery.svg";
import icReturn from "../../../images/eshop/30arrow.png";
import { connect } from "react-redux";
import { countryList } from "../../../models";
import i18next from "i18next";

let $ = window.$;

class Delivery extends React.Component {
  formatCurrency() {}

  changeDeliveryFee = async event => {
    const { fetchDutyTax } = this.props;
    const countryCode = event.target.value;
    await fetchDutyTax(countryCode);
  };

  popup = () => {
    window.postMessage("OPEN_FREE_RETURN_WINDOW", "*");
  };

  render() {
    const {
      returnable,
      countryList,
      getCountriesList,
      productData,
      activeCountry
    } = this.props;
    const { deliveryDate, shippingFee } = this.props.dutyTax;
    const lang = i18next.language;

    return (
      <>
        <section>
          <Translation>
            {t => (
              <p className="smallSubtitle">
                {t("delivery.shippingInformation")}
              </p>
            )}
          </Translation>
          <table className="table-shipping-info">
            <tbody>
              <tr>
                <td className="col-icon">
                  <img src={icInstore} alt="" loading="lazy" />
                </td>
                <td>
                  <div className="text-body-2">
                    <Translation>
                      {t => <b>{t("delivery.deliveryCollection")}</b>}
                    </Translation>
                  </div>
                  <Translation>
                    {t => <p>{t("delivery.orderOnlineCollect")}</p>}
                  </Translation>
                </td>
              </tr>
              <tr>
                <td className="col-icon">
                  <img src={icLocalDelivery} alt="" loading="lazy" />
                </td>
                <td>
                  <div className="text-body-2">
                    <Translation>
                      {t => <b>{t("delivery.hongKongLocalDelivery")}</b>}
                    </Translation>
                  </div>
                  <Translation>
                    {t => <p>{t("delivery.complimentaryDeliveryToHK")}</p>}
                  </Translation>
                </td>
              </tr>
              <tr className="box_intDelivery">
                <td className="col-icon">
                  <img src={icInternDelivery} alt="" loading="lazy" />
                </td>
                <td style={{ padding: "0px" }}>
                  <div className="text-body-2">
                    <Translation>
                      {t => <b>{t("delivery.internationalDelivery")}</b>}
                    </Translation>
                  </div>
                  <Translation>
                    {t => <p>{t("delivery.nowDeliveringToOver40")}</p>}
                  </Translation>

                  <article className="static">
                    {getCountriesList && (
                      <select
                        className="int-delivery-mobile"
                        onChange={this.changeDeliveryFee}
                        name="intDelivery"
                        value={activeCountry}
                      >
                        <Translation>
                          {t => (
                            <option value="HK" disabled="disabled">
                              {t("delivery.selectDestinationCountry")}
                            </option>
                          )}
                        </Translation>
                        {!countryList.hasOwnProperty("error") &&
                          countryList.map((data, i) => (
                            <option key={i} value={data.countryIsoCode}>
                              {data.name}
                            </option>
                          ))}
                      </select>
                    )}
                    {activeCountry !== "CN" ? (
                      <>
                        <table className="delivery-fee-table">
                          <tbody>
                            <tr className="delivery-fee-table-title">
                              <td>
                                <Translation>
                                  {t => <>{t("delivery.deliveryMode")}</>}
                                </Translation>
                              </td>
                              <td>
                                <Translation>
                                  {t => <>{t("delivery.cost")}</>}
                                </Translation>
                              </td>
                              <td>
                                <Translation>
                                  {t => <>{t("delivery.deliveryTime")}</>}
                                </Translation>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <Translation>
                                  {t => <>{t("delivery.priority")}</>}
                                </Translation>
                              </td>
                              <td>{shippingFee ? `$${shippingFee}` : "-"}</td>
                              <td>{deliveryDate ? `${deliveryDate}` : "-"}</td>
                            </tr>
                          </tbody>
                        </table>
                      </>
                    ) : (
                      <div className="china-int-delivery-text-mobile">
                        <br />
                        <Translation>
                          {t => <>{t("delivery.forShippingChina")}</>}
                        </Translation>
                        <a
                          href="https://cn.emphasis.com"
                          target="_blank"
                          className="content-link"
                          rel="noopener noreferrer"
                        >
                          <Translation>
                            {t => t("delivery.emphasis")}
                          </Translation>
                        </a>
                        <Translation>{t => t("tariff.dot")}</Translation>
                      </div>
                    )}
                  </article>
                </td>
              </tr>
            </tbody>
          </table>
          <br />
          <br />
          {/* <Translation>
            {t => (
              <p>
                {t("delivery.forDetailsPleaseVisit")}
                <a
                  href={`/${
                    lang === "zhTW" ? "tc" : "en"
                  }/help-shippinginformation`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="content-link"
                >
                  {t("delivery.shippingInformation")}
                </a>
              </p>
            )}
          </Translation> */}
        </section>
        <section>
          <Translation>
            {t => (
              <p className="smallSubtitle">
                {t("delivery.includedWithYourOrder")}
              </p>
            )}
          </Translation>

          <ul className="list-inclued">
            <Translation>
              {t => <li>{t("delivery.certificates")}</li>}
            </Translation>
            <Translation>
              {t => <li>{t("delivery.invoiceForAfterSales")} </li>}
            </Translation>
            <Translation>
              {t => <li>{t("delivery.giftReadyPackaging")}</li>}
            </Translation>
          </ul>

          <img
            className="imgPackingImage"
            src={productData.media.packingImage}
            alt=""
            loading="lazy"
          />
        </section>
        <section style={{ marginBottom: "0" }}>
          <Translation>
            {t => (
              <p className="smallSubtitle">{t("delivery.returns&Exchanges")}</p>
            )}
          </Translation>
          <table className="table-return-exchange">
            <tbody>
              <tr>
                <td className="col-icon">
                  <img src={icReturn} alt="" loading="lazy" />
                </td>
                <td>
                  <div className="text-body-2">
                    <Translation>
                      {t => <b>{t("delivery.return&ExchangePolicy")}</b>}
                    </Translation>
                  </div>
                  {(returnable && (
                    <Translation>
                      {t => (
                        <p onClick={this.popup} style={{cursor: "pointer"}}>
                          {t("rightIndex.returnExchange2")}
                          <br />
                        </p>
                      )}
                    </Translation>
                  )) ||
                    null}
                  <div>
                    <Translation>
                      {t => (
                        <p>
                          <a
                            href={`/${
                              lang === "zhTW" ? "tc" : "en"
                            }/experience/return-exchange`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="content-link"
                            style={{
                              cursor: "pointer",
                              textDecoration: "none",
                              color: "#c69967",
                              borderBottom: "#c69967 1px solid"
                            }}
                          >
                            {t("delivery.findOutMore")}
                          </a>
                        </p>
                      )}
                    </Translation>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </section>
      </>
    );
  }
}
const mapStateToProps = state => {
  return {
    returnable: state.product.productBookingUnit.returnable,
    countryList: state.countryList.countries,
    getCountriesList: state.countryList.getCountriesList,
    dutyTax: state.countryList.dutyTax,
    productData: state.product.productBookingUnit,
    activeCountry: state.countryList.activeCountry
  };
};
const mapDispatchToProps = () => {
  return {
    fetchDutyTax: countryCode => countryList.actions.fetchDutyTax(countryCode)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Delivery);
